export default {
	mounted: el => {
		/*function loadImage() {
			const imageElement = Array.from(el.children).find(
				el => el.nodeName === "IMG"
			);
			if (imageElement) {
				imageElement.addEventListener("load", () => {
					setTimeout(() => el.classList.add("loaded"), 100);
				});
				imageElement.addEventListener("error", (m) => console.log("error", m));
				imageElement.src = imageElement.dataset.url;
			}
		}*/
		function loadImage() {
			const imageElement = Array.from(el.children).find(
				el => el.nodeName === "IMG"
			);

			if (imageElement) {

				el.classList.add("loading");
				console.log("FP: added loading class");

				imageElement.addEventListener("load", () => {
					el.classList.remove("loading");
					el.classList.add("loaded");
				});

				imageElement.addEventListener("error", (m) => {
					el.classList.remove("loading");
					console.log("error", m);
				});

				imageElement.src = imageElement.dataset.url;
			}
		}

		function handleIntersect(entries, observer) {
			entries.forEach(entry => {
				if (entry.isIntersecting) {
					loadImage();
					observer.unobserve(el);
				}
			});
		}

		function createObserver() {
			const options = {
				//root: null,
				//threshold: "0"
				threshold: 0.01,
				rootMargin: '75%',
			};
			const observer = new IntersectionObserver(handleIntersect, options);
			observer.observe(el);
		}
		if (window["IntersectionObserver"]) {
			//console.log("FP: image: createObserver() ");
			
			createObserver();
			
			
		} else {
			//console.log("FP: image: loadImage() ");
			loadImage();
		}
	}
};